import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { RestApiService } from '../../../../src/app/rest-api.service';


@Injectable({
	providedIn: 'root'
})
export class MyApplicationService implements Resolve<any>{
	rows: any;
	onSettingsChanged: BehaviorSubject<any>;
	/**
   * Constructor
   *
   * @param {HttpClient} _httpClient
   */
	constructor(public api: RestApiService,
		private _httpClient: HttpClient) {

		this.onSettingsChanged = new BehaviorSubject({});
	}
	/**
   * Resolver
   *
   * @param {ActivatedRouteSnapshot} route
   * @param {RouterStateSnapshot} state
   * @returns {Observable<any> | Promise<any> | any}
   */
	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
		// return new Promise<void>((resolve, reject) => {
		// 	Promise.all([this.getDataTableRows()]).then(() => {
		// 		resolve();
		// 	}, reject);
		// });
	}

	/**
	 * Get rows
	 */
	// getDataTableRows(): Promise<any[]> {
	// 	return new Promise((resolve, reject) => {
	// 		this._httpClient.get('api/account-settings-data').subscribe((response: any) => {
	// 			this.rows = response;
	// 			this.onSettingsChanged.next(this.rows);
	// 			resolve(this.rows);
	// 		}, reject);
	// 	});
	// }
	/*** Apply online form submit **/
	getEuttcApplicationList(data) {
		return this.api.post("/applyonlineEuttcList", data);
	}
	getEuttcApplicationDetail(data) {
		return this.api.post("/viewEuttcApplicationDetails", data);
	}
	downloadEuttcSummeryReport(data){
		return this.api.post("/downloadEuttcSummeryReport", data);
	}

	downloadEuttcSummeryxlsReport(data){
		return this.api.post("/downloadEuttcSummeryxlsReport", data);
	}
	downloadEuttcApplicationSummaryData(data) {
		var URL = this.api.post("/downloadEuttcApplyonlineSummaryPdf", data);
		return URL;
	}
	getCoeApplicationList(data) {
		return this.api.post("/applyonlineCoeList", data);
	}
	getCoeApplicationDetail(data) {
		return this.api.post("/viewCoeApplicationDetails", data);
	}

	downloadCoeSummeryReport(data){
		return this.api.post("/downloadCoeSummeryReport", data);
	}

	downloadCoeSummeryxlsReport(data){
		return this.api.post("/downloadCoeSummeryxlsReport", data);
	}

	downloadCoeApplicationSummaryData(data) {
		var URL = this.api.post("/downloadCoeApplyonlineSummaryPdf", data);
		return URL;
	}

	getApplicationList(data) {
		return this.api.post("/applyonlineList", data);
	}

	/*** Forward to Extert **/
	forwardToExpert(data) {
		return this.api.post("/saveExpertRemark", data);
	}

	/*** Upload signed document **/
	uploadSignedDocument(data) {
		return this.api.postDirect("/uploadSignedDocument", data);
	}

	uploadDocument(data) {
		return this.api.postDirect("/uploadDocument", data);
	}

	/*** Upload signed document **/
	submitExpertEvalutionDetails(data) {
		return this.api.postDirect("/addExpertCommentRating", data);
	}

	/*** Upload signed document **/
	approveComments(data) {
		return this.api.post("/acceptRejectExpert", data);
	}


	/*** Apply online form submit **/
	getApplicationDetail(data) {
		return this.api.post("/viewApplicationDetails", data);
	}

	/*** Apply online form submit **/
	getExpertCommentByID(data) {
		return this.api.post("/listExpertComments", data);
	}

	downloadApplicationData(data) {
		var URL = this.api.post("/downloadApplyonlinePdf", data);
		return URL;
	}

	downloadApplicationSummaryData(data) {
		var URL = this.api.post("/downloadApplyonlineSummaryPdf", data);
		return URL;
	}

	raiseRequest(data) {
		return this.api.post("/raiseRequestDetails", data);
	}
	sendMessage(data) {
		return this.api.post("/sendMessage", data);
	}
	getSanctionDetials(data) {
		return this.api.post("/getSanctionDetails", data);
	}
	submitProgressData(data) {
		return this.api.postDirect("/saveProgressReport", data);
	}
	getprogressReportDetail(data) {
		return this.api.post("/getProgressReportDetails", data);
	}

	getPendingProgressReportData(data) {
		return this.api.post("/getPendingProgressReportData", data);
	}

	approveRejectProgressData(data) {
		return this.api.postDirect("/approveRejectProgressReport", data);
	}
	submitCompletionReportData(data) {
		return this.api.postDirect("/saveCompletionReport", data);
	}

	getBankMandateDetail(data) {
		return this.api.post("/getBankMandateDetails", data);
	}
	submitBankMandateData(data) {
		return this.api.postDirect("/saveBankMandateDetails", data);
	}
	getreviewReportDetails(data) {
		return this.api.post("/getProgressReportData", data);
	}
	CompletionReport(data) {
		return this.api.post("/downloadCompletionReport", data);
	}
	completionReportDetails(data) {
		return this.api.post("/getCompletionReportDetails", data);
	}
	submitProfileData(data) {
		return this.api.postDirect("/updateUserProfile", data);
	}
	getProfileData(){
		return this.api.post("/getProfileData", {});
	}
	submitAgendaData(data) {
		return this.api.postDirect("/saveMeetingAgenda", data);
	}
	getMeetingAgendaDetail(data){
		return this.api.post("/getMeetingAgendaDetails", data);
	}
	getMeetingAgendaPdf(data) {
		return this.api.post("/downloadMeetingAgendaPdf", data);
	}
	getMISreport(data){
		return this.api.post("/downloadMIS", data);
	}
	updatePassword(data){
		return this.api.post("/auth/changePassword", data);
	}

	getManpowerForCompletionReport(data) {
		return this.api.post("/manpowerForCompletionReport", data);
	}
	getReleasedProgressReportData(data) {
		return this.api.post("/getProgressReportReleasedData", data);
	}
	getMessageData(data){
		return this.api.post("/getMessageDetails", data);
	}
	downloadSummeryReport(data){
		return this.api.post("/downloadSummeryReport", data);
	}
	getExpertList(data){
		return this.api.post("/expertList", data);
	}
	getUserList(data){
		return this.api.post("/userList", data);
	}
	getCustomerList(data){
		return this.api.post("/customerList", data);
	}
	saveExpertDetails(data){
		return this.api.postDirect("/addExpert", data);
	}
	getExpertData(data){
		return this.api.post("/getExpertDetails", data);
	}
	getUserData(data){
		return this.api.post("/getUserDetails", data);
	}
	updateExpertStatus(data){
		return this.api.post("/updateExpertStatus", data);
	}
	updateExpertCommentsStatus(data){
		return this.api.post("/approveRejectCommentsAgainstExpert", data);
	}
	approveRejectApplication(data){
		return this.api.post("/approveRejectApplication", data);
	}

	addVisitorCount(data){
		return this.api.post("/common/addVisitorCount", data);
	}

	getVisitorCount(data){
		return this.api.post("/common/getVisitorCount", data);
	}
}
